import HomeCaretakersPage from "./HomeCaretakersPage";

export default HomeCaretakersPage;
